import { createSurveyStyles } from '@sm/webassets';
import { Theme } from '@wds/styles';
import { evaluateTextColorVisibility, getThemeColors } from '~app/pages/EnterpriseThankYou/helpers/themeColors';

type StyleNames = 'container' | 'headerText' | 'headerTextInner';
type StyleProps = { wrenchTheme: Theme };

const useStyles = createSurveyStyles<StyleNames, StyleProps>(theme => {
  const { headerTextColor, bodyTextColor, backgroundColor } = getThemeColors(theme);
  const visibleColor = evaluateTextColorVisibility(headerTextColor, bodyTextColor, backgroundColor);
  return {
    container: {
      padding: [[24, 0, 0, 0]],
      margin: [0, 'auto'],
      maxWidth: 308,
    },
    '@media (min-width: 1024px)': {
      container: {
        width: '100%',
      },
    },
    headerText: {
      color: visibleColor,
      fontFamily: theme?.pageTitle?.fontFamily,
    },
    headerTextInner: ({ wrenchTheme }) => ({
      fontSize: 36,
      fontWeight: wrenchTheme.type.fontWeight.medium,
      textAlign: 'center',
      lineHeight: 'initial',
      margin: 0,
    }),
  };
});

export default useStyles;
